
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/internal/operators/tap';
import { Observable } from 'rxjs/internal/Observable';


import { HttpHeader } from '../constants/app.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from '../cache/cache.constant';
import { Environment } from '../environment/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  /*********************Constructor*********************/
  constructor(private sessionStorage: SessionStorageService) { }
  /*********************Constructor*********************/

  /*********************Implementation Methods*********************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to add authorization token in header.
    let token = null;

    const cloneRequest = request.clone({
      setHeaders: this.setAuthTokenHeader(request.headers, request)
    });

    // Pass on the cloned request instead of the original request.
    return next.handle(cloneRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.verifyAuthToken(event);
        }
      })
    );

  }

  /*********************Implementation Methods*********************/

  /*********************Private Methods*********************/

  /**
   * Set authorization token for every http requests
   * @param headers Default Http Headers
   */
  private setAuthTokenHeader(headers: HttpHeaders, request: HttpRequest<any>) {
    const requestHeaders: any = {};
    let accessToken = null;
    let idToken = null;
    let authToken = null;
    let refreshToken=null;
    let isAccountCall = (request.url.trim().indexOf('/account') >= 0) ? true : false;
    let isAccountChangeCall = (request.url.trim().indexOf('/accountChange?') >= 0) ? true : false;
    let isGenerateTokenCall = (request.url.trim().indexOf('/generate/jwtforoktab2b') >= 0) ? true : false;
    let url = window.location.href;
    accessToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.AccessToken);
    authToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.AuthToken);
    idToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.IdToken);
    refreshToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.RefreshToken);

    if (url.includes('ACCESS_TOKEN')) {
      const httpparams = new HttpParams({ fromString: url });
      idToken = httpparams.get('ID_TOKEN');
      if (httpparams.get('ACCESS_TOKEN')) {
        accessToken = httpparams.get('ACCESS_TOKEN');
      } else {
        const httpparams1 = new HttpParams({ fromString: url.split('ACCESS_TOKEN')[1] });
        accessToken = httpparams1.get('');
      }
      if (httpparams.get('AUTH_TOKEN')) {
        authToken = httpparams.get('AUTH_TOKEN');
      } else {
        const httpparams2 = new HttpParams({ fromString: url.split('AUTH_TOKEN')[1] });
        authToken = httpparams2.get('');
      }
      refreshToken=httpparams.get('REFRESH_TOKEN');


      this.sessionStorage.store(CacheConstant.SessionStorageData.AccessToken, accessToken);
      this.sessionStorage.store(CacheConstant.SessionStorageData.IdToken, idToken);
      this.sessionStorage.store(CacheConstant.SessionStorageData.AuthToken, authToken);
      this.sessionStorage.store(CacheConstant.SessionStorageData.RefreshToken, refreshToken);
    }

      if(authToken && !request.url.includes('/token/jwtforoktab2b')){
        requestHeaders['access-token'] = authToken;
      }
      if(isGenerateTokenCall){
        requestHeaders['okta-access-token']= accessToken;
        requestHeaders['okta-id-token']=  idToken;
      }
    requestHeaders['x-api-key'] = Environment.getInstance().appConfig.apiKey; //'TDM6cgXT9OH4q0FaQ7XVldkkGPUSNTbW';
    if (headers.keys().length > 0) {
      headers.keys().forEach(key => {
        requestHeaders[key] = headers.get(key);
      });
    }
    return requestHeaders;
  }

  /**
   * Check for updated authorization token for every http response and update in cache.
   * @param response Http Service Response
   */
  private verifyAuthToken(response: HttpResponse<any>) {
    // const accessTokenKey = response.headers
    //   .keys()
    //   .filter(key => key.toLowerCase() === HttpHeader.Token.toLowerCase())[0];

    // if (accessTokenKey) {
    //   //this.tokenService.set(response.headers.get(accessTokenKey));
    // }
  }

  /*********************Private Methods*********************/
}


